import {rootAction, rootActionDownload} from "../apiAction";
import {SET_USER} from "../user/actions";


export const REQUEST_GET_DETAILS = 'REQUEST_GET_DETAILS';
export const SUCCESS_GET_DETAILS = 'SUCCESS_GET_DETAILS';
export const FAILURE_GET_DETAILS = 'FAILURE_GET_DETAILS';
export const CLEAR_REQUEST_DETAILS = 'CLEAR_REQUEST_DETAILS';

export const REQUEST_DOWNLOAD_FILE_FROM_REQUEST = 'REQUEST_DOWNLOAD_FILE_FROM_REQUEST';
export const SUCCESS_DOWNLOAD_FILE_FROM_REQUEST = 'SUCCESS_DOWNLOAD_FILE_FROM_REQUEST';
export const FAILURE_DOWNLOAD_FILE_FROM_REQUEST = 'FAILURE_DOWNLOAD_FILE_FROM_REQUEST';
export const CLEAR_DOWNLOAD_FILE_FROM_REQUEST_INFO = 'CLEAR_DOWNLOAD_FILE_FROM_REQUEST_INFO';

export const REQUEST_DOWNLOAD_FILE_FROM_ARCHIVE = 'REQUEST_DOWNLOAD_FILE_FROM_ARCHIVE';
export const SUCCESS_DOWNLOAD_FILE_FROM_ARCHIVE = 'SUCCESS_DOWNLOAD_FILE_FROM_ARCHIVE';
export const FAILURE_DOWNLOAD_FILE_FROM_ARCHIVE = 'FAILURE_DOWNLOAD_FILE_FROM_ARCHIVE';
export const CLEAR_DOWNLOAD_FILE_FROM_ARCHIVE = 'CLEAR_DOWNLOAD_FILE_FROM_ARCHIVE';

// export const REQUEST_DOWNLOAD_FILE_LIST_FROM_REQUEST = 'REQUEST_DOWNLOAD_FILE_LIST_FROM_REQUEST';
// export const SUCCESS_DOWNLOAD_FILE_LIST_FROM_REQUEST = 'SUCCESS_DOWNLOAD_FILE_LIST_FROM_REQUEST';
// export const FAILURE_DOWNLOAD_FILE_LIST_FROM_REQUEST = 'FAILURE_DOWNLOAD_FILE_LIST_FROM_REQUEST';
// export const CLEAR_FILE_LIST = 'CLEAR_FILE_LIST const';

export const REQUEST_DOWNLOAD_FILE_FROM_LIST = 'REQUEST_DOWNLOAD_FILE_FROM_LIST';
export const SUCCESS_DOWNLOAD_FILE_FROM_LIST = 'SUCCESS_DOWNLOAD_FILE_FROM_LIST';
export const FAILURE_DOWNLOAD_FILE_FROM_LIST = 'FAILURE_DOWNLOAD_FILE_FROM_LIST';


export const getRequestDetails = (requestId, page, size) => dispatch => {
  return dispatch(rootAction(
    'GET',
    `/notary/esb/details?requestId=${requestId}`,
    null,
    {
      request: REQUEST_GET_DETAILS,
      success: SUCCESS_GET_DETAILS,
      failure: FAILURE_GET_DETAILS
    }
  ));
};

export const clearRequestDetails = () => dispatch => {
  return dispatch({
      type: CLEAR_REQUEST_DETAILS,
    }
  )
};

// export const clearFilesList = () => dispatch => {
//   return dispatch({
//       type: CLEAR_FILE_LIST,
//     }
//   )
// };


export const downloadFileFromRequest = ( spSiteUrl, spFolderServerRelativeUrl, fileName) => dispatch =>{
  return dispatch(rootActionDownload(
    {
      spSiteUrl: spSiteUrl,
      spFolderServerRelativeUrl:spFolderServerRelativeUrl,
      fileName: fileName
    },
    'POST',
    `/notary/esb/file`,
    fileName,
    {
      request: REQUEST_DOWNLOAD_FILE_FROM_REQUEST,
      success: SUCCESS_DOWNLOAD_FILE_FROM_REQUEST,
      failure: FAILURE_DOWNLOAD_FILE_FROM_REQUEST
    }
  ));
}


export const downloadFileFromArchive = ( documentDownloadUrl, fileName) => dispatch =>{
  return dispatch(rootActionDownload(
    null,
    'POST',
    `/notary/esb/ceaFile?documentDownloadUrl=${documentDownloadUrl}`,
    fileName,
    {
      request: REQUEST_DOWNLOAD_FILE_FROM_ARCHIVE,
      success: SUCCESS_DOWNLOAD_FILE_FROM_ARCHIVE,
      failure: FAILURE_DOWNLOAD_FILE_FROM_ARCHIVE
    }
  ));
}




// export const downloadFileListFromRequest = ( requestId, fileName) => dispatch =>{
//   return dispatch(rootAction(
//     'GET',
//     `/notary/esb/ceaList?requestId=${requestId}`,
//     fileName,
//     {
//       request: REQUEST_DOWNLOAD_FILE_LIST_FROM_REQUEST,
//       success: SUCCESS_DOWNLOAD_FILE_LIST_FROM_REQUEST,
//       failure: FAILURE_DOWNLOAD_FILE_LIST_FROM_REQUEST
//     }
//   ));
// }
//
// export const downloadFileFromList = ( documentDownloadUrl, fileName) => dispatch =>{
//   return dispatch(rootActionDownload(
//     null,
//     'GET',
//     `/notary/esb/ceaFile?documentDownloadUrl=${documentDownloadUrl}`,
//     fileName,
//     {
//       request: REQUEST_DOWNLOAD_FILE_LIST_FROM_REQUEST,
//       success: SUCCESS_DOWNLOAD_FILE_LIST_FROM_REQUEST,
//       failure: FAILURE_DOWNLOAD_FILE_LIST_FROM_REQUEST
//     }
//   ));
// }


